/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { TabBarBodyLayout } from '@veeam-vspc/shared/components';

import { ActivityLog } from './components';

export interface EventLogActivityLogPageProps {
    currentPath?: string;
}

export const EventLogActivityLogPage: React.FC<EventLogActivityLogPageProps> = ({ currentPath }) => (
    <TabBarBodyLayout>
        <ActivityLog stateId={currentPath} />
    </TabBarBodyLayout>
);
